import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import api from '../services';
import { IMG_BASE_URL } from '../Helpers'
import BookGrid from './BookGrid';
import BookSlider from './BookSlider';
export default function SameAuthorBooks({ authorId, bookId }) {
    const [sameAuthorBooks, setSameAuthorBooks] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        fetchSameAuthorBooks(authorId);
    }, []);

    const fetchSameAuthorBooks = async (authorId) => {
        try {
            const data = await api("GET", `booksBySameAuthor/${authorId}`);
            setSameAuthorBooks(data.filter((book) => book.book_id !== bookId));
        } catch (error) {
            console.error("Error fetching related books:", error);
        }
    };
    const authorName = sameAuthorBooks[0]?.authors?.[0]?.author_name || "Author";
    const sliderTitle = `Books of ${authorName}`;
    return (
        <>
            {sameAuthorBooks.length > 0 && (
                // <section className="py-5 bg-light">
                //     <div className="container px-4 px-lg-5 mt-5">
                //         <h5 className="fw-bolder mb-4">Books of {sameAuthorBooks[0].authors[0].author_name} </h5>
                //         <BookGrid
                //             books={sameAuthorBooks}
                //             onViewBook={(book) => navigate('/book-details', { state: { book } })}
                //         />
                //     </div>
                // </section>
                <BookSlider books={sameAuthorBooks} sliderTitle={sliderTitle} />
            )}
        </>
    )
}
